
import { default as _theme_github_45light } from "shiki/themes/github-light.mjs";
import { default as _theme_github_45dark } from "shiki/themes/github-dark.mjs";
import { default as _theme_min_45light } from "shiki/themes/min-light.mjs";
import { default as _theme_min_45dark } from "shiki/themes/min-dark.mjs";
import { default as _lang_bash } from "shiki/langs/bash.mjs";
import { default as _lang_python } from "shiki/langs/python.mjs";
import { default as _lang_yaml } from "shiki/langs/yaml.mjs";
import { default as _lang_json } from "shiki/langs/json.mjs";
import { default as _lang_typescript } from "shiki/langs/typescript.mjs";
import { default as _lang_javascript } from "shiki/langs/javascript.mjs";

export const shikiOptions = {
  highlight: {
  "lang": "bash",
  "themes": {
    "light": "github-light",
    "dark": "github-dark"
  }
},
  core: {
    themes: [_theme_github_45light, _theme_github_45dark, _theme_min_45light, _theme_min_45dark],
    langs: [_lang_bash, _lang_python, _lang_yaml, _lang_json, _lang_typescript, _lang_javascript],
    langAlias: undefined,
  },
};
